module.exports = __webpack_public_path__ + "img/gk_logo.9609f155.png";